import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Spinner from 'react-spinkit';

import GroupForm, { CREATE, UPDATE } from '../components/GroupForm';
import {
    ASSIGNMENT__MEMBERSHIPS__REQUESTED,
    ASSIGNMENT__SUBMISSIONS__REQUESTED,
    DROPBOXES__REQUESTED,
    DROPBOX__ASSIGNMENT__REQUESTED,
    DROPBOXES__ROLES__REQUESTED,
    DROPBOX__USERS__REQUESTED,
    ROLES__SELF__REQUESTED
} from "../constants/actionTypes";
import _ from "lodash";
import { getMappedKeyEntities, spaceToUnderscore } from "../helpers/helpers";

class AssignmentGroupsPage extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const { dispatch } = this.props;

        dispatch({
            type: ROLES__SELF__REQUESTED
        });
    }

    componentDidUpdate(prevProps) {
        const { assignment, dispatch, dropboxes, memberships, params, roles_self, submissions, users } = this.props,
            { assignmentName, dropboxName } = params
        ;


        if (prevProps.roles_self !== roles_self) {
            dispatch({
                type: DROPBOXES__REQUESTED
            });

            dispatch({
                type: DROPBOX__ASSIGNMENT__REQUESTED,
                payload: {
                    dropboxName : dropboxName,
                    assignmentName : assignmentName
                }
            });
        }

        if (prevProps.dropboxes !== dropboxes) {
            const dropbox = this.getDropbox(),
                dropboxId = dropbox.id
            ;

            if (users.dropbox !== dropboxId) {
                dispatch({
                    type: DROPBOXES__ROLES__REQUESTED,
                    payload: { dropboxId },
                });

                dispatch({
                    type: DROPBOX__USERS__REQUESTED,
                    payload: { dropboxId },
                });
            }
        }

        if (prevProps.assignment !== assignment) {
            const assignmentId = assignment.id;

            if (memberships.assignment !== assignmentId) {
                dispatch({
                    type: ASSIGNMENT__MEMBERSHIPS__REQUESTED,
                    payload: { assignmentId },
                });
            }

            if (submissions.assignment !== assignmentId) {
                dispatch({
                    type: ASSIGNMENT__SUBMISSIONS__REQUESTED,
                    payload: { assignmentId },
                });
            }
        }
    }

    getDropbox() {
        const { dropboxes, params } = this.props;

        return _.last(
            _.filter (dropboxes, dropbox => {
                return dropbox.name === params.dropboxName;
            })
        );
    }

    getSubmission() {
        const { auth, memberships, submissions } = this.props;

        let membership = _.last(
            _.filter(
                getMappedKeyEntities(memberships),
                membership => {
                    return membership.user.id === parseInt(auth.id);
                }
            )
        );
        membership = membership ? membership : {};

        let { submission } =  membership;

        submission = submission ? submission : {};

        return submissions[submission.id] ? submissions[submission.id] : {};
    }

    render() {
        const isLoading = this.props.request.sendingRequest;

        if (isLoading) {
            return (
                <Spinner
                    spinnerName="wandering-cubes"
                    className="spinner"
                    noFadeIn
                />
            );
        }

        const { assignment, params } = this.props,
            dropbox = this.getDropbox(),
            submission = this.getSubmission()
        ;

        return assignment && dropbox
        ?
            <GroupForm
                assignment={assignment}
                className="group-form"
                dropbox={dropbox}
                params={params}
                submission={submission}
                type={_.size(submission) < 1 || location.pathname.match(/create[/]{0,1}$/) ? CREATE : UPDATE}
            />
        : null;
    }
}

AssignmentGroupsPage.propTypes = {
    auth: PropTypes.object.isRequired,
    assignment: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    dropboxes: PropTypes.object.isRequired,
    params: PropTypes.object.isRequired,
    request: PropTypes.object.isRequired,
    loadingBar: PropTypes.number.isRequired,
    memberships: PropTypes.object.isRequired,
    roles: PropTypes.object.isRequired,
    roles_self: PropTypes.object.isRequired,
    submissions: PropTypes.object.isRequired,
    users: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
    const { auth, assignment, dropboxes, loadingBar, memberships, request, roles, roles_self, submissions, users } = state;

    return { auth, assignment, dropboxes, loadingBar, memberships, request, roles, roles_self, submissions, users };
}

export default connect(mapStateToProps)(withRouter(AssignmentGroupsPage));



/** WEBPACK FOOTER **
 ** ./src/containers/AssignmentGroupsPage.js
 **/